import { render, staticRenderFns } from "./supplierChangePassword.vue?vue&type=template&id=c7fc6070&scoped=true&"
import script from "./supplierChangePassword.vue?vue&type=script&lang=js&"
export * from "./supplierChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./supplierChangePassword.vue?vue&type=style&index=0&id=c7fc6070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fc6070",
  null
  
)

export default component.exports